import { AllForms } from "../../utils/functionsInterfaces";
import { displayError } from "../../utils/messageToast";
import { SetupFlow } from "../../apis/apisFlowByAuthorizationRA";

export const getAllForms = async (
  setLoadingPage: React.Dispatch<React.SetStateAction<boolean>>,
  token: string,
  ambient: string,
  setAllForm: React.Dispatch<React.SetStateAction<AllForms[]>>,
  currentPage: number,
  itemsPerPage: number,
  setCountForms: React.Dispatch<React.SetStateAction<number>>
) => {
  try {
    setLoadingPage(true);

    const apiClient1 = SetupFlow(token);
    console.log("token", token);
    
    const response = await apiClient1.get(
      `/get-all-forms?ambient=${ambient}&page=${currentPage}&itemsPerPage=${itemsPerPage}`
    );
    const forms = response.data.mapForms;

    setAllForm(forms);
    setCountForms(response.data.count);
    setLoadingPage(false);
    return response.data;
  } catch (error: any) {
    // displayError("Erro ao buscar formulários!");
    return;
  } finally {
    setLoadingPage(false);
  }
};
